import { SignedInFooter } from '@chegg-me-components/signed-in-footer'
import { Config } from '@chegg-wt/core/config'
import {
  legalCookieNotice,
  legalInfoSellText,
  navFeedback,
  navHelpCenter,
} from './constants'

export const HOME_PAGE_FOOTER_TEST = 'home-page-footer-test'

const HomePageFooter = () => (
  <SignedInFooter
    navLinks={[
      {
        text: 'Academic Integrity',
        href: 'https://www.chegg.com/about/academic-integrity/',
        useAbsolute: true,
      },
      {
        text: 'Feedback',
        href: navFeedback[Config.siteName],
        useAbsolute: true,
      },
      {
        text: 'Help Center',
        href: navHelpCenter[Config.siteName],
        useAbsolute: true,
      },
      {
        text: 'Manage Subscription',
        href: 'https://www.chegg.com/my/orders',
        useAbsolute: true,
      },
      {
        text: 'Advertise with us',
        href: 'https://collegemarketing.chegg.com',
        useAbsolute: true,
      },
    ]}
    legalLinks={[
      {
        text: 'Cookie Notice',
        href: legalCookieNotice[Config.siteName],
        useAbsolute: true,
      },
      {
        text: 'Your privacy choices',
        href:
          'https://privacyportal.onetrust.com/webform/a21a74f4-2f93-44a2-a887-302a9213c997/06b040b7-49eb-464a-b19a-ea35c85c79fc',
        useAbsolute: true,
      },
      {
        text: legalInfoSellText[Config.siteName],
        href: '#',
        configuration: {
          elementClassName: 'ot-sdk-show-settings',
          elementId: 'ot-sdk-btn',
        },
        useAbsolute: true,
      },
      {
        text: 'General Policies',
        href: 'https://www.chegg.com/en-US/generalpolicies',
        useAbsolute: true,
      },
      {
        text: 'Privacy Policy',
        href: 'https://www.chegg.com/en-US/privacypolicy',
        useAbsolute: true,
      },
      {
        text: 'Honor Code',
        href: 'https://www.chegg.com/en-US/honorcode',
        useAbsolute: true,
      },
      {
        text: 'IP Rights',
        href: 'https://www.chegg.com/en-US/copyright',
        useAbsolute: true,
      },
    ]}
    data-test={HOME_PAGE_FOOTER_TEST}
    envUrl={Config.baseUrl}
  />
)

export default HomePageFooter
